import { render, staticRenderFns } from "./home-payment.vue?vue&type=template&id=55bd2a28&scoped=true"
import script from "./home-payment.vue?vue&type=script&lang=js"
export * from "./home-payment.vue?vue&type=script&lang=js"
import style0 from "./home-payment.vue?vue&type=style&index=0&id=55bd2a28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55bd2a28",
  null
  
)

export default component.exports